const CardLegend = {
  fontSize: { md: '1.2rem', xl: '1.7rem' },
  color: '#ADADAD'
}

const CardValue = {
  padding: '0 0 0 1rem',
  fontSize: { md: '1.8rem', xl: '2.2rem' }
}

const cardIconSx = {
  marginLeft: { xs: '-8px', lg: '-15px' },
  width: { md: 68, xl: 92 },
  height: { md: 68, xl: 92 }
}

const cardStyle = {
  padding: { xs: '8px 5px', lg: '8px 22px' }
}
const cardStyleClickable = {
  padding: { xs: '8px 5px', lg: '8px 22px' },
  cursor: 'pointer'
}

const cardContentSx = { display: 'flex', justifyContent: 'center' }
const cardActionsSx = { display: 'flex', justifyContent: 'center' }

export {
  CardLegend,
  CardValue,
  cardIconSx,
  cardStyle,
  cardContentSx,
  cardActionsSx,
  cardStyleClickable
}
